import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IApiBackendRouteService } from '../abstract/api-routes.service';
import { API_ENDPOINTS } from '../../../core/providers/constants/api.constants';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ApiRouteSchedulerWorkOrderService extends IApiBackendRouteService {
  constructor(protected readonly http: HttpClient) {
    super();
  }

  urlRoute = `${API_ENDPOINTS.SCHEDULER_PROCESS}/work-order`;

  setItemStage(body: {
    machineId: number;
    workOrderId: number;
    stage: string;
  }): Observable<any> {
    return this.http.post(`${this.urlRoute}/set-stage`, {
      ...body
    });
  }
}
